
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/captive-insurance",
      function () {
        return require("private-next-pages/solutions/captive-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/captive-insurance"])
      });
    }
  